import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './NavLinks.module.scss';

const navLinks = [
  {
    path: '/research',
    label: 'Research',
  },
  {
    path: '/search',
    label: 'Signal Search',
  },
  {
    path: '/chat',
    label: 'Chat',
  },
];

interface NavLinksProps {
  onLinkClick?: () => void;
  direction?: 'row' | 'column';
}

const NavLinks: React.FC<NavLinksProps> = ({ onLinkClick, direction = 'row' }) => {
  return (
    <div className={`${styles.navLinks} ${direction === 'column' ? styles.column : ''}`}>
      {navLinks.map((link) => (
        <NavLink
          key={link.path}
          to={link.path}
          className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ''}`}
          onClick={onLinkClick}
        >
          <div className={styles.navLinkContainer}>
            {link.label}
            {link.label === 'Chat' && <span className={styles.betaTag}>Beta</span>}
          </div>
        </NavLink>
      ))}
    </div>
  );
};

export default NavLinks;
